/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class MessageTemplatesAPI extends ApiClient {
  constructor() {
    super('wasapi/message_templates', { accountScoped: true });
  }

  list(inboxId) {
    return axios.get(this.url, { params: { inbox_id: inboxId } });
  }

  createTemplate(inboxId, template) {
    return axios.post(this.url, { inbox_id: inboxId, ...template });
  }

  updateTemplate(inboxId, id, template, status) {
    return axios.patch(`${this.url}/${id}`, {
      inbox_id: inboxId,
      status,
      ...template,
    });
  }

  deleteTemplate(inboxId, id, name) {
    return axios.delete(`${this.url}/${id}`, {
      params: { inbox_id: inboxId, name },
    });
  }

  uploadMedia(inboxId, file) {
    const form = new FormData();
    form.append('inbox_id', inboxId);
    form.append('file', file);
    return axios.post(`${this.url}/upload_media`, form);
  }
}

export default new MessageTemplatesAPI();
